import React from 'react';

interface CustomInfoShieldIconProps {
  size?: number;
}

const CustomInfoShieldIcon: React.FC<CustomInfoShieldIconProps> = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size * 21) / 20}
    viewBox="0 0 20 21"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9.75 9.53613V13.2861M9.75 0.75C7.48574 2.90023 4.47027 4.07958 1.348 4.036C0.950735 5.2463 0.748871 6.51217 0.750005 7.786C0.750005 13.378 4.574 18.076 9.75 19.408C14.926 18.076 18.75 13.378 18.75 7.786C18.75 6.476 18.54 5.216 18.152 4.036H18C14.804 4.036 11.9 2.786 9.75 0.75Z" />
    <path d="M9.75 7.06752L9.75 7.03613" />
  </svg>
);

export default CustomInfoShieldIcon;
